export default function Tooltip (theme: any) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.grey[0],
          fontSize: 11,
          textAlign: 'justify'
        },
        arrow: {
          color: theme.palette.primary.main
        }
      }
    }
  }
}
